<template>
  <div class="page_main">
    <my_menu2 :page_name="project_info.project_name + '结算历史记录'" back_type="close" back_icon="md-close"></my_menu2>

    <!-- <div class="head_box">
      <div class="head_left">
        <img class="logo_img" src="@/assets/image/auth/logo_white.png" alt="" />
        <span class="head_title">{{ project_info.project_name }}·结算历史记录</span>

        <div class="back_home" @click="bank_home">&nbsp;&nbsp;|&nbsp;&nbsp;返回首页</div>
      </div>
      <div class="head_right"></div>
    </div> -->

    <div style="height: 50px"></div>
    <div class="record_card_list">

      <div class="add_options">
        <div class="add_options_1">
          <div class="add_options_12">
            <span>ID搜索：</span>
            <Input search @on-clear="search_clear" @on-search="search_record()" v-model="jiesuan_id" size="small"
              clearable placeholder="ID搜索" style="width: 120px" />
            <span style="margin-left: 10px">备注搜索：</span>
            <Input search @on-clear="search_clear" @on-search="search_record()" v-model="remarks_search" size="small"
              clearable placeholder="备注模糊搜索" style="width: 120px" />
            <div class="hide_zeero">
              <Checkbox v-model="hide_zeero_flag" @on-change="hide_zeero_change">
                <span style="font-size: 12px">隐藏非正常数据</span>
              </Checkbox>
            </div>
          </div>

          <div style="yushou_money">项目预收余额：{{ yushou_balance }}元</div>
        </div>
        <div>
          <Button style="font-size: 12px; margin-right: 10px" @click="click_export" size="small">
            导出表格
          </Button>
          <Button style="font-size: 12px; margin-right: 10px" @click="invoice_zuofei" size="small" type="error">
            <Icon type="ios-cut" />
            发票作废申请
          </Button>

          <Button style="font-size: 12px" @click="add_jiesuan" size="small" type="primary">
            <Icon type="md-add-circle" />
            发起结算
          </Button>
        </div>
      </div>
      <div class="table_div">
        <Spin fix v-if="loading">
          <Icon type="ios-loading" size="26" class="demo-spin-icon-load"></Icon>
          <div>正在玩命加载中..</div>
        </Spin>

        <Table size="small" :height="windowHeight - 190" show-summary :columns="columns" :data="record_list" ref="table"
          @on-selection-change="table_selection_change">
          <template #jiesuan_short_id="{ row }">
            <div class="table_index" @click="click_view_invoice(row)">
              {{ row.jiesuan_short_id }}
              查看详情
            </div>
          </template>

          <template #create_status="{ row }">
            <div class="table_index">
              <Tag v-if="row.create_status == 1" color="primary">批量</Tag>
              <Tag v-if="row.create_status == 0">常规</Tag>
            </div>
          </template>

          <template #flow="{ row }">
            <span class="flow" @click="click_flow(row)">查看流程</span>
          </template>

          <template #jiesuan_status="{ row }">
            <div class="table_index">
              <Tooltip :content="row.no_pass_remarks" placement="top-start">
                <Tag v-if="row.jiesuan_status == 1" color="error">驳回</Tag>
              </Tooltip>

              <Tag v-if="row.jiesuan_status == 0">正常</Tag>
              <Tag v-if="row.jiesuan_status == 2" color="error">作废(全部)</Tag>
              <Tag v-if="row.jiesuan_status == 3" color="error">作废(部分)</Tag>
            </div>
          </template>

          <template #make_status="{ row }">
            <Tag color="success" v-if="row.make_status == 1">开票完成</Tag>
            <Tag color="warning" v-if="row.make_status == 0">待开票</Tag>
          </template>

          <template #make_invoice_type="{ row }">
            <div v-if="row.make_status == 1">
              <span v-if="row.make_invoice_type == 0"> 纸质 </span>
              <span v-if="row.make_invoice_type == 1"> 电子 </span>
              <span v-if="
                row.make_status == 1 &&
                row.jiesuan_status == 0 &&
                row.make_invoice_type == 1
              " style="color: #0f79fc" class="invoice_count" @click="down_invoice(row)">
                (下载-{{ row.electronic_list.length }})
              </span>
            </div>
            <div v-else>--</div>
          </template>

          <template #invoice_count="{ row }">
            <div class="invoice_count" @click="click_view_invoice(row)">
              {{ row.invoice_count }}张
            </div>
          </template>

          <template #express_number="{ row }">
            <span class="invoice_count" @click="click_express_number(row)">
              {{ row.express_number }}
            </span>
          </template>

          <template #action="{ row }">
            <span class="del_record" @click="del_record(row)">删除</span>
          </template>
        </Table>
      </div>
      <div class="page_div">
        <Page show-total @on-change="page_change" :total="total_count" :page-size="limit" />
      </div>


    </div>

    <!-- <Modal draggable title="查看结算发票详情（可拖拽）" :closable="true" width="850" v-model="show_invoice_template"> -->

    <Drawer title="查看结算发票详情" width="90" draggable placement="left" :closable="true" v-model="show_invoice_template">
      <div class="template_main_div">
        <div class="template_title">
          发票共
          <Tag color="primary">{{ template_invoice_list.length }}张</Tag>点击左右箭头可切换发票
        </div>

        <Alert v-if="jiesuan_info.jiesuan_status == 1" type="error">该申请被驳回，原因：{{ jiesuan_info.no_pass_remarks }}
        </Alert>
        <Alert v-if="jiesuan_info.jiesuan_status == 2" type="error">该申请中的发票已经作废</Alert>

        <div class="view_template">
          <Spin fix v-if="loading2">
            <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
            <div>Loading</div>
          </Spin>
          <invoice_template v-if="template_invoice_list" ref="invoice_template" :invoice_list="template_invoice_list">
          </invoice_template>
        </div>

        <div class="drawer_div">
          <div class="draser_file_title">结算说明/备注:</div>
          <div>
            {{ jiesuan_info.remarks }}
          </div>
        </div>
        <div class="drawer_div">
          <div class="draser_file_title">发票票面备注:</div>
          <div>
            {{ jiesuan_info.piaomian_remarks }}
          </div>
        </div>

        <div class="drawer_div">
          <div class="draser_file_title">企业原表:</div>
          <div class="excel_div_main">
            <div v-for="(item, i) in jiesuan_file_list" :key="i" class="excel_div"
              @click="download_excel(item.object_name)">
              <span class="iconfont iconExcel"></span>
              <div class="excel_name">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="drawer_div">
          <div class="draser_file_title">大湘统一结算表</div>
          <div class="excel_div_main">
            <div  class="excel_div" @click="download_excel(jiesuan_universal_file_item.object_name)">
              <span class="iconfont iconExcel"></span>
              <div class="excel_name">
                {{ jiesuan_universal_file_item.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="drawer_div">
          <div class="draser_file_title">开票资料确认表:</div>
          <div class="excel_div_main">
            <div v-for="(item, i) in make_invoice_file_list" :key="i" class="excel_div"
              @click="download_excel(item.object_name)">
              <span class="iconfont iconExcel"></span>
              <div class="excel_name">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="drawer_div">
          <div class="draser_file_title">邮寄信息：</div>
          <div class="">
            <div v-if="JSON.stringify(address_info) != '{}'">
              {{ address_info.name }} / {{ address_info.phone }} /
              {{ address_info.detail }}
            </div>
            <div v-else>没有邮寄信息,无需邮寄</div>
          </div>
        </div>
      </div>
    </Drawer>

    <Modal draggable title="查看电子发票" :closable="true" width="400" v-model="view_electronic_show">
      <div class="view_electronic_div">
        <div v-for="(item, i) in current_electronic_list" :key="i" style="margin: 0 10px 10px 0">
          <Button type="" @click="electronic_invoice_download(item)">电子发票{{ i + 1 }}</Button>
        </div>
      </div>
    </Modal>

    <Modal draggable :title="'发票作废(' + zuofie_jiesuan_short_id + ')'" :closable="true" width="500" :footer-hide="true"
      v-model="zuofei_show">
      <div>
        <div class="zuofei_fangfa">
          操作方法：1勾选要作废的发票，2填写作废原因，3提交即可
        </div>
        <Table size="small" height="150" ref="zuofei" :columns="zuofei_colums" :data="zuofei_table"
          @on-selection-change="zuofei_table_selection_change"></Table>
      </div>
      <div class="zuofeiyuanyin">
        <span class="zfyytitle">作废原因：</span>
        <Input v-model="zuofei_remarks" placeholder="请输入作废原因" />
      </div>
      <div class="zuofei_btn">
        <Button :loading="zuofei_loading" type="primary" style="font-size: 13px"
          @click="zuofei_invoice_confirm">确认提交作废</Button>
      </div>
    </Modal>

    <query_express_info ref="query_express_info"></query_express_info>
    <view_flow ref="view_flow"></view_flow>
  </div>
</template>

<script>
import { http, open_new_page, get_view_file_url } from "@/utils/http.js";
import invoice_template from "./invoice_template";
import query_express_info from "@/component/express/query_express_info";
import my_menu2 from "@/component/menu/menu2.vue";
import view_flow from "@/component/flow/view_flow.vue";

export default {
  components: {
    invoice_template,
    query_express_info,
    my_menu2,
    view_flow,
  },

  data() {
    return {
      project_id: "",
      loading: false,
      record_list: [],
      invoice_money_total: 0,
      returned_money_total: 0,
      weihuikuan_total: 0,
      project_info: {
        project_name: "",
      },
      page: 1,
      limit: 20,

      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      show_invoice_template: false,
      template_invoice_list: [],
      loading2: false,
      make_invoice_file_list: [],
      address_info: {},
      jiesuan_file_list: [],
      jiesuan_id: "",
      jiesuan_info: {},
      yushou_balance: 0,

      view_electronic_show: false,
      current_electronic_list: [],
      hide_zeero_flag: false,

      // 选中列表
      selection_list: [],
      zuofie_jiesuan_short_id: "",
      zuofei_colums: [],
      zuofei_table: [],
      zuofei_remarks: "",
      zuofei_show: false,
      zuofei_loading: false,
      //
      zuofei_select_list: [],

      remarks_search: "",
      jiesuan_universal_file_item:{}
    };
  },

  mounted() {
    this.project_id = this.$route.query.project_id;
    this.jiesuan_id = this.$route.query.jiesuan_id;
    this.open_invoice = this.$route.query.open_invoice;
    if (this.jiesuan_id == undefined) {
      this.jiesuan_id = "";
    }

    console.log(this.jiesuan_id);

    this.get_record_list();
    this.window_change();
  },
  methods: {
    // 发票作废提交
    zuofei_invoice_confirm() {
      if (this.zuofei_select_list.length == 0) {
        this.$Message.error("请勾选至少一张作废的发票");
        return;
      }

      if (this.zuofei_remarks == "") {
        this.$Message.error("请输入作废原因");
      }

      var obj = {
        invoice_data_list: this.zuofei_select_list,
        remarks: this.zuofei_remarks,
        project_id: this.project_id,
      };
      var that = this;
      this.zuofei_loading = true;
      http("post", process.env.VUE_APP_HOST + "/finance/invoice/zuofei_audit", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.zuofei_loading = false;
        })
        .catch((res) => {
          that.zuofei_loading = false;

          console.log(res, "请求出错");
        });
    },

    zuofei_table_selection_change(e) {
      this.zuofei_select_list = e;
    },

    table_selection_change(e) {
      this.selection_list = e;
    },

    invoice_zuofei() {
      if (this.selection_list.length == 0) {
        this.$Message.error("请先选择一个");
        return;
      }
      if (this.selection_list.length > 1) {
        this.$Message.error("只能选择一个");
        return;
      }
      if (this.selection_list[0]["make_status"] != 1) {
        this.$Message.error("需要开票完成才可申请");
        return;
      }

      this.zuofie_jiesuan_short_id = this.selection_list[0]["jiesuan_short_id"];

      var that = this;
      var obj = {
        jiesuan_id: this.selection_list[0].jiesuan_id,
      };
      this.loading2 = true;
      http("post", process.env.VUE_APP_HOST + "/finance/invoice/jiesuan_info", obj, true)
        .then((res) => {
          if (res.code == 0) {
            this.zuofei_table = res.data.data_list;
            this.zuofei_colums = [
              { type: "selection", width: 55 },
              { key: "invoice_type_name", width: 90, title: "类型" },
              { key: "total_money", width: 120, title: "发票金额" },
              { key: "audit_id", width: 200, title: "发票ID" },
            ];
            this.zuofei_show = true;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.loading2 = false;
        })
        .catch((res) => {
          that.loading2 = false;

          console.log(res, "请求出错");
        });
    },

    hide_zeero_change() {
      this.get_record_list();
    },

    electronic_invoice_download(url) {
      open_new_page(url);
    },

    down_invoice(row) {
      this.current_electronic_list = row.electronic_list;
      this.view_electronic_show = true;
    },

    click_express_number(item) {
      this.$refs.query_express_info.open(item.express_number, item.express_phone);
    },

    bank_home() {
      open_new_page("/");
    },

    click_view_invoice(row) {
      this.show_invoice_template = true;

      var that = this;
      var obj = {
        jiesuan_id: row.jiesuan_id,
      };
      this.loading2 = true;
      http("post", process.env.VUE_APP_HOST + "/finance/invoice/jiesuan_info", obj, true)
        .then((res) => {
          if (res.code == 0) {
            this.template_invoice_list = res.data.data_list;
            this.$refs.invoice_template.open(res.data.data_list, false);

            if (that.template_invoice_list.length == 0) {
              this.$Message.info("没有记录");
            }
            this.make_invoice_file_list = res.data.make_invoice_file_list;
            this.jiesuan_file_list = res.data.jiesuan_file_list;
            this.jiesuan_info = res.data.jiesuan_info;
            this.address_info = res.data.address_info;
            this.jiesuan_universal_file_item = res.data.jiesuan_universal_file_item
            
            
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.loading2 = false;
        })
        .catch((res) => {
          that.loading2 = false;

          console.log(res, "请求出错");
        });
    },

    add_jiesuan() {
      var url = "/finance/kaipiao?project_id=" + this.project_id;
      open_new_page(url);
    },

    window_change() {
      var that = this;
      // <!--把window.onresize事件挂在到mounted函数上-->
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          window.fullWidth = document.documentElement.clientWidth;
          that.windowHeight = window.fullHeight; // 高
          that.windowWidth = window.fullWidth; // 宽
        })();
      };
    },
    updateQueryParam(key, value) {
      // 创建一个新的查询参数对象
      let newQuery = { ...this.$route.query };
      // 设置或修改查询参数
      newQuery[key] = value;
      // 使用`this.$router.push`来更新URL的查询参数
      this.$router.push({ path: this.$route.path, query: newQuery });
    },

    //获取结算历史记录
    get_record_list() {
      var that = this;
      var obj = {
        project_id: this.project_id,
        jiesuan_id: this.jiesuan_id,
        remarks: this.remarks_search,
        page: this.page,
        limit: this.limit
      };
      this.loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/invoice/jiesuan_record",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            this.columns = res.data.columns;
            this.invoice_money_total = res.data.invoice_money_total;
            this.returned_money_total = res.data.returned_money_total;
            this.weihuikuan_total = res.data.weihuikuan_total;
            this.project_info = res.data.project_info;
            this.yushou_balance = res.data.yushou_balance;
            this.total_count = res.data.total_count

            if (this.hide_zeero_flag == false) {
              this.record_list = res.data.record_list;
            } else {
              var new_list = [];
              for (var i = 0; i < res.data.record_list.length; i++) {
                if (res.data.record_list[i]["jiesuan_status"] == 0) {
                  new_list.push(res.data.record_list[i]);
                }
              }
              this.record_list = new_list;
            }
            if (this.record_list.length == 0) {
              this.$Message.info("没有记录");
            }
            if (this.open_invoice == 1) {
              this.updateQueryParam("jiesuan_id", "");
              this.updateQueryParam("open_invoice", "0");
              this.click_view_invoice(this.record_list[0]);
            }
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.loading = false;
        })
        .catch((res) => {
          that.loading = false;

          console.log(res, "请求出错");
        });
    },

    download_excel(url) {
      get_view_file_url(url);
      // open_new_page(url);
    },

    search_record() {
      this.get_record_list();
    },

    search_clear() {
      this.$router.push({
        path: "/finance/kaipiao_detail",
        query: {
          project_id: this.project_id,
        },
      });
      this.get_record_list();
    },

    del_record(item) {
      var that = this;
      this.$Modal.confirm({
        title: "提示",
        content: "<p>正在删除，是否继续？</p>",
        onOk: () => {
          that.del_record_request(item);
        },
        onCancel: () => { },
      });
    },

    del_record_request(item) {
      var that = this;
      var obj = {
        jiesuan_id: item.jiesuan_id,
        project_id: item.project_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/invoice/jiesuan_record_del",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.get_record_list();
            that.$Message.success(res.msg);
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_export() {
      this.$refs.table.exportCsv({
        filename: this.project_info.project_name + "-结算历史记录-导出",
      });
    },

    click_flow(row) {
      this.$refs.view_flow.open(row.flow_data)
    },

    page_change(e) {
      this.page = e
      this.get_record_list()
    }
  },
};
</script>

<style scoped>
.table_div {
  position: relative;
}

.page_div {
  padding: 5px;
  display: flex;
  justify-content: center;
}

.flow {
  color: #3489f1;
  cursor: pointer;
}


.zuofeiyuanyin {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.zfyytitle {
  width: 80px;
  flex-shrink: 0;
}

.zuofei_fangfa {
  font-size: 12px;
  margin-bottom: 10px;
}

.zuofei_btn {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.view_electronic_div {
  display: flex;
  flex-wrap: wrap;
}

.template_main_div {
  height: calc(100vh - 100px);
  overflow: auto;
}

.hide_zeero {
  margin-left: 10px;
}

.add_options_12 {
  margin-right: 20px;
  display: flex;
  align-items: center;
}

.add_options_1 {
  display: flex;
  align-items: center;
}

.yushou_money {
  padding-left: 20px;
}

.del_record {
  color: red;
  cursor: pointer;
}

.back_home {
  color: #96badd;
  cursor: pointer;
}

.back_home:hover {
  color: #fff;
}

.excel_div_main {
  display: flex;
  flex-wrap: wrap;
}

.table_index {
  cursor: pointer;
  color: #0466dd;
}

.draser_file_title {
  font-size: 14px;
  font-weight: 600;
  margin-right: 30px;
  flex-shrink: 0;
}

.drawer_div {
  border: 1px solid #e7e7e7;
  padding: 10px 20px;
  align-items: center;
  display: flex;
  margin-bottom: 10px;
  /* border-radius: 5px; */
  /* box-shadow: 0 0 3px #e6e6e6; */
}

.iconExcel {
  font-size: 34px;
  margin-right: 10px;
  color: #1c840e;
}

.excel_name {
  color: #333;
  font-size: 12px;
  display: flex;
  align-items: center;
  text-align: left;
}

.excel_div {
  width: 200px;
  margin-right: 10px;
  margin-bottom: 10px;
  text-align: center;
  cursor: pointer;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 0 5px;
  overflow-wrap: break-word;
  display: flex;
}

.excel_div:hover {
  border: 1px solid #195faf;
}

.view_template {
  /* position: relative; */
}

.template_title {
  font-weight: 600;
  text-align: center;
  font-size: 14px;
  color: #000;
}

.invoice_count {
  font-size: 12px;
  color: #195faf;
  cursor: pointer;
}

.add_options {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.count_title {
  font-size: 13px;
}

.count_card_div {
  display: flex;
  padding: 0 10px;
}

.count_card {
  margin-right: 10px;
  padding: 10px;
  border-radius: 5px;
  width: 150px;
  text-align: center;
  background-color: #fff;
}

.left_div {
  width: 320px;
  flex-shrink: 0;
  border-right: 1px dashed #ccc;
}

.demo-spin-col .circular {
  width: 25px;
  height: 25px;
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}

.record_card_list {
  margin: 0 10px 0 10px;
  padding: 10px;
  background-color: #fff;
  height: calc(100vh - 60px);
  border-radius: 5px;
}

.record_card:hover {
  box-shadow: 0 0 5px #8fa2bc;
  cursor: pointer;
}

.invoice_money {
  font-weight: 600;
  color: red;
}

.card_title {
  width: 100px;
  flex-shrink: 0;
}

.card_1 {
  display: flex;
  align-items: center;
}

.right_div {
  padding-left: 30px;
}

.left_main {
  display: flex;
}

.tijiaoren {
  font-size: 13px;
  color: #ccc;
}

.create_time {
  border-bottom: 1px solid #e5e5e5;
  margin-bottom: 5px;
  padding-bottom: 5px;
  display: flex;
  justify-content: space-between;
}

.page_main {
  min-height: 100vh;
  background-color: #ececec;
}

.record_card {
  background-color: #fff;
  padding: 10px;
  margin: 10px;
  border-radius: 5px;
}

/* 顶部 */

.logo_img {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}

.head_title {
  cursor: pointer;
  letter-spacing: 3px;
  font-size: 14px;
  font-weight: 400;
  color: rgb(255, 255, 255);
}

.head_left {
  display: flex;
  align-items: center;
}

.head_box {
  /* background: #195faf; */
  background: #0466dd;
  height: 40px;
  display: flex;
  z-index: 99;
  width: 100vw;
  position: fixed;
  top: 0;
  justify-content: space-between;
  align-items: center;
  padding: 0 0 0 20px;
}

/*  */
</style>
